 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import {Menu} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'
import {PALETTE} from '~/styles/paletteV3'
import {ICON_SIZE} from '~/styles/typographyV2'
import {AppBar} from '~/types/constEnums'

import PlainButton from './PlainButton/PlainButton'
import TopBarHelp from './TopBarHelp'
import TopBarIcon from './TopBarIcon'
import TopBarNotifications from './TopBarNotifications'






const Wrapper = styled('header')({
  backgroundColor: PALETTE.GRAPE_700,
  display: 'flex',
  height: AppBar.HEIGHT,
  maxWidth: '100%'
})

const LeftNavToggle = styled(PlainButton)({
  fontSize: ICON_SIZE.MD24,
  lineHeight: '16px',
  paddingLeft: 16
})

const LeftNavHeader = styled('div')({
  alignItems: 'center',
  color: PALETTE.SLATE_200,
  display: 'flex',
  flex: 1,
  minWidth: 0
})

const TopBarIcons = styled('div')({
  alignItems: 'center',
  color: PALETTE.SLATE_200,
  display: 'flex',
  justifyContent: 'flex-end',
  maxWidth: 560,
  paddingRight: 16
})

const Title = styled('div')({
  fontSize: 20,
  overflow: 'hidden',
  paddingLeft: 16,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
})

const MobileDashTopBar = (props) => {
  const {toggle, queryRef} = props
  const data = useFragment(
    graphql`
      fragment MobileDashTopBar_query on Query {
        ...TopBarNotifications_query
        viewer {
          pageName
        }
      }
    `,
    queryRef
  )
  const {viewer} = data
  const pageName = _nullishCoalesce(_optionalChain([viewer, 'optionalAccess', _ => _.pageName]), () => ( 'Parabol'))
  return (
    React.createElement(Wrapper, null
      , React.createElement(LeftNavHeader, null
        , React.createElement(LeftNavToggle, { onClick: toggle,}
          , React.createElement(Menu, null )
        )
        , React.createElement(Title, null, pageName)
      )
      , React.createElement(TopBarIcons, null
        /* Disable search in mobile for now */
        , false && React.createElement(TopBarIcon, { icon: 'search', ariaLabel: 'Search',} )
        , React.createElement(TopBarHelp, null )
        , React.createElement(TopBarNotifications, { queryRef: data || null,} )
      )
    )
  )
}

export default MobileDashTopBar
